// Module
var code = "<a name=nodePinAction ng-mousedown=execute($event) class=nlgAnalysisTreePropertyIcon style=cursor:pointer> <i style=margin-top:0 ng-class=\"property.value ? 'fa fa-lock':'fa fa-lock-open'\"></i> </a> ";
// Exports
module.exports = code;